export default __webpack_public_path__ + "static/media/disconnect.4ad7c6b7.svg";